import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import SupportStatusLabel from 'components/importer/support_status_label';

export default function SupportStatusSelector({ activeStatus, statusOptions, onChange }) {
  if (statusOptions.length < 1) {
    return null;
  }

  const handleChange = (status) => {
    onChange(status);
  };

  const formatOptionLabel = supportStatus => (
    <SupportStatusLabel supportStatus={supportStatus} />
  );

  return (
    <div style={{ minWidth: '150px' }}>
      <Select
        formatOptionLabel={formatOptionLabel}
        isSearchable={false}
        options={statusOptions}
        value={activeStatus}
        onChange={handleChange}
      />
    </div>
  );
}

SupportStatusSelector.propTypes = {
  activeStatus: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  statusOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  onChange: PropTypes.func.isRequired
};
